"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.ZERO_MAX_AGE = exports.VISITOR_CODE_MAX_LENGTH = exports.VISITOR_CODE_LENGTH = exports.PATH = exports.DEFAULT_MAX_AGE = void 0;
var VISITOR_CODE_LENGTH = exports.VISITOR_CODE_LENGTH = 16,
  VISITOR_CODE_MAX_LENGTH = exports.VISITOR_CODE_MAX_LENGTH = 255,
  DEFAULT_MAX_AGE = exports.DEFAULT_MAX_AGE = 31536000,
  ZERO_MAX_AGE = exports.ZERO_MAX_AGE = 0,
  PATH = exports.PATH = "/";